import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthState } from 'react-firebase-hooks/auth';
import { doc, setDoc, updateDoc, getDocs, query, collection, where } from 'firebase/firestore';
import { firestore, auth, googleProvider } from '../firebase';
import { signInWithPopup } from 'firebase/auth';
import { v4 as uuidv4 } from 'uuid';
import axios from 'axios';
import appConfig from '../config/appConfig.json';
import { useDebounce } from 'use-debounce';
import ReactMarkdown from 'react-markdown';
import ReactGA from 'react-ga4';

import './UserDetailsInterface.css';
import { createApi } from '@reduxjs/toolkit/query';

const UserDetailsInterface = () => {
  const [loading, setLoading] = useState(false);
  const [userDetails, setUserDetails] = useState({ name: '', dob: '', time: '', location: '', language: '' });
  const [lat, setLat] = useState(null);
  const [lon, setLon] = useState(null);
  const [step, setStep] = useState(0);
  const [input, setInput] = useState('');
  const [messages, setMessages] = useState([]);
  const [predictions, setPredictions] = useState([]);
  const [isTyping, setIsTyping] = useState(false);
  const [debouncedLocation] = useDebounce(input, 300);
  const chatWindowRef = useRef(null);
  const [errorMessage, setErrorMessage] = useState('');
  const [locationSelected, setLocationSelected] = useState(false);
  const [isLocationSent, setIsLocationSent] = useState(false);
  const [isInputEnabled, setIsInputEnabled] = useState(false);
  const [showSignupPopup, setShowSignupPopup] = useState(false);
  const [hasNameSent, setHasNameSent] = useState(false);
  const [pendingQuestion, setPendingQuestion] = useState('');
  const [processingResponse, setProcessingResponse] = useState(false);
  const [startChat, setStartChat] = useState(false);
  const [platform, setPlatform] = useState('Web');
  const [referralCode, setReferralCode] = useState(''); // State for referral code
  // const [showSignupPopup, setShowSignupPopup] = useState(false);
  const submitLock = useRef(false);
  const navigate = useNavigate();
  const userId = uuidv4();
  const [user] = useAuthState(auth);

  const questions = [
    { id: 1, text: "🙏 Namaste! To answer your questions accurately, may I have your name to get started?" },
    { id: 2, text: `Thank you, ${userDetails.name}! That’s a lovely name. Please provide your date of birth.` },
    { id: 3, text: "Could you please provide your time of birth?" },
    { id: 4, text: "We're almost there! Tell me where you were born?" },
    { id: 5, text: "Perfect! Please select your preferred language."},
    { id: 6, text: "Look's great! Your kundli has been generated. Enter your email id to start chat with the astrologer."}
  ];

  const languages = ["Hinglish (Hindi written in english)", "English", "Hindi", "Amharic", "Arabic", "Bengali", "Burmese", "Cebuano", "Dutch", "French", "Fula", "German", "Gujarati", "Hakka Chinese", "Hausa", "Hebrew", "Igbo", "Indonesian", "Italian", "Japanese", "Javanese", "Kannada", "Korean", "Malayalam", "Mandarin Chinese", "Marathi", "Oromo", "Pashto", "Persian (Farsi)", "Polish", "Portuguese", "Romanian", "Russian", "Serbo-Croatian", "Sinhala", "Spanish", "Swahili", "Sundanese", "Tagalog (Filipino)", "Tamil", "Telugu", "Thai", "Turkish", "Ukrainian", "Urdu", "Vietnamese", "Wu Chinese (Shanghainese)", "Xhosa", "Yue Chinese (Cantonese)", "Zulu"];

  const formatDate = () => {
    const now = new Date();
    const day = String(now.getDate()).padStart(2, '0');
    const month = String(now.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const year = now.getFullYear();
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    
    return `${day}-${month}-${year} ${hours}:${minutes}`;
  };

  const fetchAstrologyDetails = async (userData) => {

    try {
      const response = await axios.post(`${appConfig.REACT_APP_BACKEND_URL}/api/astrology-details`, userData);
      if (response.status === 200) {
        const astroData = response.data;
        const updatedUserDetails = {
          ...userDetails,
          astro_data: astroData, 
        };
        setUserDetails(updatedUserDetails);
  
        // Update Firestore with astrology data
        const userRef = doc(firestore, 'users', userId);
        await updateDoc(userRef, { astro_data: astroData });
        // addMessage("bot", "Look's great! Your kundli has been generated. Enter your email id to start chat with the astrologer");
        setStartChat(true); 
        // setIsTyping(true);
        // // Pass the updated user details with astro data to fetchUserSummary
        // // console.log("details passed to get summary function",updatedUserDetails);
        // setTimeout(() => fetchUserSummary(updatedUserDetails), 5000);
      }
    } catch (error) {
      console.error("Error fetching astrology details:", error);
      setMessages((prevMessages) => [
        ...prevMessages,
        { text: 'Error fetching astrology details. Please try again.', sender: 'bot' },
      ]);
    }
  };
  
  // Function to fetch user summary from backend
  // const fetchUserSummary = async (userData) => {
  //   // console.log("user data from fetchUser Summary function", userData);
  //   setIsTyping(true);
  //   try {
  //     const response = await axios.post(`${appConfig.REACT_APP_BACKEND_URL}/chat/get-user-summary`, userData);
  //     if (response.status === 200) {
  //       const summary = response.data.summary;
  //       addMessage("bot", summary); // Display summary to user
  //     }
  //   } catch (error) {
  //     console.error("Error fetching user summary:", error);
  //     addMessage("bot", "Error generating your astrology summary. Please try again later.");
  //   } finally {
  //     setIsTyping(false);
  //     setIsInputEnabled(true);
  //     setStep(questions.length); 
  //   }
  // };

  // Function to track a button click event
  
  const getPlatform = () => {
    if (window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone) {
      return 'PWA';
    }
    return 'Website';
  };
  
  const trackEvent = (category, action, label) => {
    // Function is depricated
    // ReactGA.event({
    //   category,
    //   action: action + " - " + getPlatform(),
    //   label,
    //   platform: getPlatform(),
    // });
  };

  const trackGA4Event = (eventName, params = {}) => {
    ReactGA.event(eventName, {
      platform: getPlatform(), // optional, if you want
      ...params,
    });
  };

  useEffect(() => {
    const detectPlatform = () => {
      const isPWA = window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone;
      return isPWA ? 'PWA' : 'Web';
    };
    setPlatform(detectPlatform());
}, []);

  useEffect(() => {
    if (chatWindowRef.current) {
      chatWindowRef.current.scrollTop = chatWindowRef.current.scrollHeight;
    }
  }, [messages]);

  useEffect(() => {
    if (step < questions.length) {
      setIsTyping(true);
      setTimeout(() => {
        setIsTyping(false);
        setMessages((prevMessages) => [
          ...prevMessages,
          { sender: 'bot', text: questions[step].text, inputType: questions[step].type, placeholder: questions[step].placeholder, time: new Date().toLocaleTimeString() }
        ]);
      }, 1000);
    }
  }, [step]);

  useEffect(() => {
    if (debouncedLocation && step === 3 && !locationSelected) {
      fetchLocationPredictions(debouncedLocation);
    }
  }, [debouncedLocation, locationSelected]);
  
  useEffect(() => {
    if (predictions.length > 0 && chatWindowRef.current) {
      // Delay scroll to ensure it captures rapid updates in predictions
      const scrollTimeout = setTimeout(() => {
        chatWindowRef.current.scrollTop = chatWindowRef.current.scrollHeight;
      }, 100); // Adjust the delay if necessary
  
      return () => clearTimeout(scrollTimeout); // Clean up on component unmount or re-render
    }
  }, [predictions]);

  const addMessage = (sender, text) => {
    if ("Look's great! Your kundli has been generated. Enter your email id to start chat with the astrologer" === text) {
      if (!processingResponse) {
        setProcessingResponse(true);
      }
      else {
        return;
      }
    }
    setMessages((prevMessages) => [...prevMessages, { sender, text, time: new Date().toLocaleTimeString() }]);
  };

  // Function to add an input field below each question
  const addInputField = (step) => {
    const question = questions[step];
    let inputType = 'text';
    let placeholder = '';

    switch (step) {
      case 0: placeholder = "Enter Full Name. E.g. Krishna Kumar"; break;
      case 1: inputType = 'date'; placeholder = "Enter your Date of Birth"; break;
      case 2: inputType = 'time'; placeholder = "Enter your Time of Birth"; break;
      case 3: placeholder = "Type your birth location..."; break;
      case 4: placeholder = "Select your preferred language"; break;
      case 5: placeholder = "Enter your email. E.g. example@gmail.com"; break;
      default: placeholder = "Enter your response";
    }

    const handleSubmit = (e) => {
      e.preventDefault();
      if (!submitLock.current && input.trim()) {
        handleUserResponse(input);
      }
    };

    const handleInputChange = (e) => {
      setInput(e.target.value);
      if (step === 3) {
        setLocationSelected(false);
      }
    };
    
    const handleSkipContact = async () => {
      // Create a copy of the current user details
      const updatedDetails = { ...userDetails };
    
      // Mark that the user skipped entering contact details.
    // or null if you prefer
      updatedDetails.contactSkipped = true;
    
      
    
      try {
        // Save the updated user details (which includes the skip marker)
        await saveUserData(updatedDetails);
        // Update local state with the new details
        setUserDetails(updatedDetails);
        // Clear the input and move to the next step
        setInput('');
        setStep(prevStep => prevStep + 1);
      } catch (error) {
        console.error('Error skipping contact details:', error);
        setErrorMessage("There was an issue saving your information. Please try again.");
      }
    };
    
    return (
      <div className="chat-input-container">
        <form onSubmit={handleSubmit} className="chat-input">
          {step === 4 ? (
            // Language selection dropdown for step 4
            <div className="custom-dropdown">
              <select 
                value={input} 
                onChange={handleInputChange}
                className="styled-select"
                disabled={submitLock.current}
              >
                <option value="" disabled>Select Language</option>
                {languages.map((lang, index) => (
                  <option key={index} value={lang}>{lang}</option>
                ))}
              </select>
              <i className="ri-arrow-down-s-line dropdown-icon"></i>
            </div>
          ) : step === 5 ? (
            // Optional contact input for step 5 with a Skip button
            
              <input
                type="text"
                value={input}
                onChange={handleInputChange}
                placeholder={placeholder}
                // Ensure this input is always enabled so the user can provide details if they want
              />
              
          ) : (
            // Default input field for other steps
            <input
              type={inputType}
              value={input}
              onChange={handleInputChange}
              placeholder={placeholder}
              onFocus={(e) => {
                if (step === 1) e.target.showPicker();
              }}
              disabled={submitLock.current}
            />
          )}
    
          {step === 3 && (predictions.length > 0 || loading) && (
            <ul className="predictions">
              {loading ? (
                <li>Finding location...</li>
              ) : (
                predictions.map((prediction) => (
                  <li 
                    key={prediction.place_id} 
                    onClick={() => handlePredictionClick(prediction)}
                  >
                    {prediction.name}
                  </li>
                ))
              )}
            </ul>
          )}
    
          <button 
            type="submit"
            disabled={submitLock.current || (!input.trim())}
          >
            <i className="ri-send-plane-fill"></i>
          </button>
        </form>
    
        {errorMessage && (
          <div className="error-message">{errorMessage}</div>
        )}
    
        {step === 0 && !hasNameSent && (
          <div className="or-continue">
            <span>or</span>
            <p onClick={handleGoogleLogin} className="continue-button">
              Login to continue
            </p>
          </div>
        )}
        {/* {step === 5 && (
          <div className="or-continue">
            <p onClick={handleSkipContact} className="skip-contact">
              skip for now...
            </p>
          </div>
        )} */}
      </div>
    );
    
  };
  

  const generateReferralCode = () => {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let code = '';
    for (let i = 0; i < 6; i++) {
      code += characters.charAt(Math.floor(Math.random() * characters.length));
    }
    return code;
  };

  const handleUserResponse = async (value) => {
    if (submitLock.current || !value.trim()) {
      return;
    }

    submitLock.current = true;
    setProcessingResponse(true);
    setErrorMessage('');

    try {
      const updatedDetails = { ...userDetails };

      // eslint-disable-next-line default-case
      switch (step) {
        case 0:
          updatedDetails.name = value;
          addMessage("user", value);
          setHasNameSent(true);
          break;
        case 1:
          updatedDetails.dob = value;
          addMessage("user", value);
          break;
        case 2:
          updatedDetails.time = value;
          addMessage("user", value);
          break;
        case 3:
          if (!locationSelected) {
            throw new Error('Please select a valid location from the list.');
          }
          updatedDetails.location = value;
          setIsLocationSent(true);
          addMessage("user", value);
          break;
        case 4:
          updatedDetails.language = value;
          addMessage("user", value);
          // For the language step, save immediately
          try {
            await saveUserData(updatedDetails);
            console.log('Language saved successfully');
            setUserDetails(updatedDetails);
            // addMessage("bot", "Look's great! Your kundli has been generated. Enter your email id to start chat with the astrologer");
          } catch (error) {
            console.error('Error saving language:', error);
            throw new Error('Failed to save language selection');
          }
          break;

        case 5:
            // For step 5 (optional contact)
            if (!value.trim()) {
              // The user has explicitly chosen to skip providing contact details.
              updatedDetails.contact = null; // or null if you prefer
              // addMessage("bot", "No worries! We'll keep you updated through your registered email.");
            } else {
              updatedDetails.contact = value;             
              try {
                await saveUserData(updatedDetails);
                trackEvent("User Profile", "Email Updated - Profile Form", "Email Updated - Profile Form");
                trackGA4Event('email_updated', {
                  source: 'onboarding'
                });
                console.log('Contact saved successfully');
                navigateToChat();
              } catch (error) {
                console.error('Error saving contact:', error);
                throw new Error('Failed to save contact selection');
              }
            }
            break;
      }

      setUserDetails(updatedDetails);
      setInput('');
      setStep(prevStep => prevStep + 1);

    } catch (error) {
      console.error('Error in handleUserResponse:', error);
      setErrorMessage(error.message);
    } finally {
      submitLock.current = false;
      setProcessingResponse(false);
    }
  };
    
  const fetchLocationPredictions = async (input) => {
    setLoading(true);
    try {
      const response = await axios.get(`${appConfig.REACT_APP_BACKEND_URL}/geocode/autocomplete`, {
        params: { text: input }
      });

      // console.log(response.data);

      if (response.data) {
        setPredictions(response.data);
      } else {
        console.error('Unexpected response structure:', response.data);
      }
    } catch (error) {
      console.error('Error fetching location predictions:', error);
    } finally {
      setLoading(false);
    }
  };

  const saveUserData = async (updatedUserDetails) => {
    console.log("Saving User Data:", updatedUserDetails);

    try {
      // Create user data object first
      const userData = {
        uid: userId,
        name: updatedUserDetails.name,
        dob: updatedUserDetails.dob,
        time: updatedUserDetails.time,
        location: updatedUserDetails.location,
        language: updatedUserDetails.language,
        contact: updatedUserDetails.contact || null,
        createdAt: formatDate(),
        totalChatCount: 0,
        RemainingchatCount: 10
      };

      console.log('Formatted user data:', userData);

      // Create reference to the document
      const userRef = doc(firestore, 'users', userId);

      // Use setDoc with merge option to ensure we don't overwrite existing data
      await setDoc(userRef, userData, { merge: true });

      // Only fetch astrology details and navigate after successful save
      await fetchAstrologyDetails(updatedUserDetails);
      trackEvent(`User Onboarding ${platform}`, 'User Details Submitted', 'Auto-Save user details');
      trackGA4Event('details_added', {
        source: 'onboarding'
      });
      navigate('/chat');
    } catch (error) {
      console.error('Error saving user data:', error);
      addMessage("bot", "There was an issue saving your information. Please try again.");
      throw error; // Re-throw to be caught by the calling function
    }
  };


  const handleGoogleSignup = async () => {
    try {
        const result = await signInWithPopup(auth, googleProvider);
        const user = result.user;
        const uid = user.uid; // Get the UID from the signed-in user
        
        // const oldUserRef = doc(firestore, 'users', userId);
        const newUserRef = doc(firestore, 'users', uid);
        
        // Generate a referral code for the new user
        const userReferralCode = generateReferralCode();
        
        await setDoc(newUserRef, {
          uid,
          RemainingchatCount: 10,
          totalChatCount: 0,
          name: user.displayName,
          email: user.email,
          profilePicture: user.photoURL,
          referralCode: userReferralCode,
          referredBy: referralCode || null, // Save the referral code used (if any)
          rewards: referralCode ? 10 : 0,
          ...userDetails, // userDetails has the necessary fields
          pendingQuestion: pendingQuestion,
          createdAt: formatDate(),
        });

        trackEvent(`User Onboarding ${platform}`, 'User Signed Up', 'Sign up for chat');
        trackGA4Event('sign_up', {
          source: 'onboarding'
        });
        if (referralCode) {
          const referrerQuery = query(
            collection(firestore, 'users'),
            where('referralCode', '==', referralCode)
          );
          const referrerSnapshot = await getDocs(referrerQuery);
    
          if (!referrerSnapshot.empty) {
            const referrerDoc = referrerSnapshot.docs[0];
            const referrerRef = referrerDoc.ref;
    
            // Update referrer's rewards
            await updateDoc(referrerRef, {
              rewards: (referrerDoc.data().rewards || 0) + 20, // Example: Reward referrer with 20 points
            });
          } else {
            console.log('Invalid referral code.');
          }
        }

        setTimeout(() => {
          navigate('/chat?signup=complete'); // Redirect to chat after delay
        }, 1500); // Redirect to chat after successful login  
    } catch (error) {
        console.error('Error signing in with Google:', error);
        alert('Error signing in with Google');
    } finally {
        setShowSignupPopup(false);
    }
  };

  const handleGoogleLogin = async () => {
    // setButtonLoading(true);
    try {
      // await signInWithPopup(auth, googleProvider);
      const result = await signInWithPopup(auth, googleProvider);
      const user = result.user;

      trackEvent(`User Activity ${platform}`, 'User Logged In', 'Logged in for chat');
      trackGA4Event('login', {
        source: 'onboarding'
      });
      localStorage.setItem('userId', user.uid); // Store user ID in local storage
      setTimeout(() => {
        navigate('/form?login=complete');
      }, 1000); // Redirect to chat after successful login
    } catch (error) {
      console.error('Error signing in with Google:', error);
      alert('Error signing in with Google');
    } finally {
      // setButtonLoading(false);
    }
  };

  const navigateToChat = async() => {
      localStorage.setItem('userId', userId);
  
      const userRef = doc(firestore, 'users', userId);

      // Generate a referral code for the new user
      const userReferralCode = generateReferralCode();
      // Save user details to Firestore
      console.log('Navigate')
      await setDoc(userRef, {
          uid: userId,
          RemainingchatCount: 10,
          totalChatCount: 0,
          referralCode: userReferralCode,
          referredBy: referralCode || null, // Store referral code if user has one
          rewards: referralCode ? 10 : 0,
          ...userDetails, // Store user details (name, dob, time, location)
          pendingQuestion: "", // Store pending question if available
          createdAt: formatDate(),
      }, { merge: true });

      trackEvent(`User Onboarding ${platform}`, 'Chat started', 'Start Chat');
      trackGA4Event('chat_initiated', {
        source: 'onboarding'
      });
      // Navigate immediately after Firestore update
      navigate('/chat?signup=skipped');
      window.location.href = '/chat?signup=skipped';
 
  }
  
  const handleQuestionSubmission = async (question) => {
      try {
          // Store session ID permanently in local storage
          localStorage.setItem('userId', userId);
  
          const userRef = doc(firestore, 'users', userId);
  
          // Generate a referral code for the new user
          const userReferralCode = generateReferralCode();
          console.log('pending question:', question);
          console.log('handle qs')
          // Save user details to Firestore
          await setDoc(userRef, {
              uid: userId,
              RemainingchatCount: 10,
              totalChatCount: 0,
              referralCode: userReferralCode,
              referredBy: referralCode || null, // Store referral code if user has one
              rewards: referralCode ? 10 : 0,
              ...userDetails, // Store user details (name, dob, time, location)
              pendingQuestion: question, // Store pending question if available
              createdAt: formatDate(),
          }, { merge: true });
  
          
          // Navigate immediately after Firestore update
          navigate('/chat?signup=skipped');
          window.location.href = '/chat?signup=skipped';
  
      } catch (error) {
          console.error('Error handling question submission:', error);
      }
  };

  // const handleQuestionSubmission = () => {
  //   // Show the signup popup after the question is submitted

  //   // setShowSignupPopup(true);
  // };

  const handlePredictionClick = (prediction) => {
    setInput(prediction.name);
    setLat(prediction.lat);
    setLon(prediction.lon);
    setPredictions([]);
    setLocationSelected(true);
  
    setUserDetails(prevDetails => ({
      ...prevDetails,
      location: prediction.name,
      lat: prediction.lat,
      lon: prediction.lon
    }));
  };

  
  return (
    <div className="chat-container">
      <div className="top-section">
        <div className="top-section-content">
          <div className="profile-pic-container">
            <img src="astro.png" alt="Astrologer" className="profile-pic" />
            <div className="status-dot"></div>
          </div>
          <div className="astrologer-info">
            <h4>Acharya Raghavendra</h4>
          </div>
        </div>
      </div>

      <div className="chat-window" ref={chatWindowRef}>
        {messages.map((msg, index) => (
          <div key={index} className={`message ${msg.sender}`}>
            <div className="message-content">
              <ReactMarkdown>{msg.text}</ReactMarkdown>
              <div className="timestamp">{msg.time}</div>
            </div>
          </div>
        ))}
        {isTyping && (
          <div className="typing-indicator">
            <div className="dot"></div>
            <div className="dot"></div>
            <div className="dot"></div>
          </div>
        )}
        {step < questions.length && (
          <div className="input-field">
            {/* Only render the input field for the location step if it hasn't been sent yet */}
            {(step !== 3 || !isLocationSent) && addInputField(step)}
          </div>
        )}
        {startChat && (
            <button className="start-chat-button" onClick={navigateToChat}>
                Start Chat
            </button>
        )}
        {isInputEnabled && !startChat && (
          <div className="chat-input">
            <input
              type="text"
              placeholder={questions[step]?.placeholder || 'Ask your question...'}
              value={input}
              onChange={(e) => setInput(e.target.value)}
              // onKeyPress={(e) => e.key === 'Enter' && handleUserResponse(input)}
            />
            {errorMessage && <div className="error-message">{errorMessage}</div>}
            {/* <button disabled={loading} onClick={() => handleUserResponse(input)} > */}
            <button disabled={loading} >
              <i className="ri-send-plane-fill"></i></button>
          </div>
        )}
        {showSignupPopup && (
          <>
            <div className="overlay" onClick={() => setShowSignupPopup(false)}></div>
            <div className="signup-popup">
              <p onClick={() => setShowSignupPopup(false)} className="cancel"><i class="ri-close-large-line"></i></p>
              <p><b>Sign up with Google to unlock free chats</b></p>
              <div className="astro-image"></div>
              <button onClick={handleGoogleSignup}><img src="https://cdn1.iconfinder.com/data/icons/google-s-logo/150/Google_Icons-09-512.png" alt="Google Logo" className='logo' />Continue with Google</button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default UserDetailsInterface;
